import React from 'react';

import { Spin } from 'antd';
import { Navigate } from 'react-router-dom';

import { useOperatorData } from '@contexts/operator/OperatorDataContext';

// Standard 方案專用：自動導向到唯一 merchant 的詳情頁
const MyMerchant = () => {
  const { merchantId, loading } = useOperatorData();

  if (loading || !merchantId) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '50vh' }}>
        <Spin size="large" />
      </div>
    );
  }

  return <Navigate to={`/merchants/${merchantId}`} replace />;
};

export default MyMerchant;
